import { FAQFilterFormValues } from "@/components/FAQFilter/FAQFilter.tsx";
import { DISPATCH_TYPE } from "../utils/enums.ts";
import {
  clearFormStateActionType,
  setFormStateActionType,
  setIsLoadingActionType
} from "@/actionTypes/formActionTypes.ts";

export const setFormStateAction = (
  formState: Partial<FAQFilterFormValues>
): setFormStateActionType => ({
  type: DISPATCH_TYPE.SET_FORM_STATE,
  payload: formState
});

export const clearFormStateAction = (): clearFormStateActionType => ({
  type: DISPATCH_TYPE.CLEAR_FORM_STATE
});

export const setIsLoadingAction = (
  isLoading: boolean
): setIsLoadingActionType => ({
  type: DISPATCH_TYPE.SET_IS_LOADING,
  payload: isLoading
});
